import React from 'react';
import Header from "./base/HeaderComponent";
import Footer from "./base/FooterComponent";

const PrivacyPolicy = () => {
    return (
        <div>
            <Header></Header>
        <div className="container py-5">
            <h1>Privacy Policy – CiSono</h1>
            <p><strong>Ultimo aggiornamento:</strong> 15/07/2025</p>

            <h3>1. Quali dati raccogliamo</h3>
            <ul>
                <li>Dati personali: email, username, nome</li>
                <li>Dati di autenticazione (Firebase)</li>
                <li>Contenuti delle chat: vocali e testuali</li>
                <li>Info di pagamento (Apple/Google Store)</li>
                <li>Dati tecnici (dispositivo, IP)</li>
            </ul>

            <h3>2. Come usiamo i tuoi dati</h3>
            <ul>
                <li>Accesso sicuro e personalizzato</li>
                <li>Gestione delle chat con operatori</li>
                <li>Miglioramento del servizio</li>
                <li>Gestione degli abbonamenti</li>
            </ul>

            <h3>3. Condivisione dei dati</h3>
            <p>Non condividiamo i tuoi dati, salvo:</p>
            <ul>
                <li>Fornitori tecnici (Firebase, SendGrid)</li>
                <li>Obblighi legali</li>
            </ul>

            <h3>4. Dove conserviamo i dati</h3>
            <p>Su Google Cloud (Firebase), server in UE/USA.</p>

            <h3>5. Per quanto tempo conserviamo i tuoi dati</h3>
            <p>I messaggi vengono conservati solo per il tempo necessario al servizio.</p>

            <h3>6. I tuoi diritti</h3>
            <p>Puoi accedere, modificare, cancellare i tuoi dati scrivendo a <strong>privacy@ci-sono.com</strong>.</p>

            <h3>7. Minori</h3>
            <p>Il servizio è riservato a maggiorenni.</p>

            <h3>8. Modifiche</h3>
            <p>Ti informeremo in app o via email in caso di aggiornamenti.</p>

            <h3>Contatti</h3>
            <p>Per dubbi o richieste: <strong>privacy@ci-sono.com</strong></p>

            <h6>Conformità: GDPR - CCPA (se applicabile)</h6>
        </div>
            <Footer></Footer>
        </div>

    );
};

export default PrivacyPolicy;
